<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallTimeChartsList></CallTimeChartsList>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import CallTimeChartsList from '../../../../components/tsConfig/hytalkPro/system/CallTimeChartsList';

export default {
  name: 'SystemCallTimeCharts',
  components: {
    BasicLayout,
    CallTimeChartsList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: '111/22222/33333'
      }
    };
  }
};
</script>

<style scoped>

</style>
